export default __webpack_public_path__ + "d09e045c6cf98e7cab829313aed51bc5.png";